module.exports = __webpack_public_path__ + "static/media/spaceBackground.eee9674d.jpg";